import { useMemo } from 'react'
import { useFullAuthzContext } from './AuthzContextProvider'
import { useAvailabilityContext } from './AvailabilityContextProvider'
import { useProvidedRecordAuthorization } from './RecordAuthorizationProvider'
import { useRecordAuthorization } from './useRecordAuthorization'
import { useRoleAuthorizationContext } from './useRoleAuthorizationContext'
import type { AccessSources } from './accessRules'
import type { AskedRecord } from './useRecordAuthorization'
import type { PermissionSetEntity } from '@omnea-app/authz'

/**
 * Every source one resolution needs, read once for a component rather than once per question. Name a
 * record only where a rule reads one: it is fetched unless the page above already holds that answer.
 */
export const useAccessSources = (asked?: AskedRecord<PermissionSetEntity>): AccessSources => {
  const authz = useFullAuthzContext()
  const role = useRoleAuthorizationContext()
  const availability = useAvailabilityContext()
  const provided = useProvidedRecordAuthorization(asked ?? null)
  const fetched = useRecordAuthorization(provided == null ? (asked ?? null) : null)

  return useMemo(
    () => ({ authz, role, availability, record: provided ?? fetched ?? undefined }),
    [authz, role, availability, provided, fetched]
  )
}
